<div class="actions">
	<app-button
		appearance="secondary"
		size="m"
		[isDisabled]="openedDropdown() === dropdownVariantEnum.ORDER_DETAILS"
		[tuiDropdownMinHeight]="600"
		[tuiDropdownMaxHeight]="600"
		[tuiDropdown]="detailsDropdown"
		[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.ORDER_DETAILS"
		(clicked)="toggleDropdown(dropdownVariantEnum.ORDER_DETAILS)"
	>
		{{ 'orders.info' | translate }}
	</app-button>
</div>

<ng-template #detailsDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-order-info-card
			[order]="order()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>
